export const toTel = (phone: string | undefined): string =>
  `tel:${(phone || "").replace(/\D+/g, "")}`;
